// extracted by mini-css-extract-plugin
export default {"formInput":"AuthForm_formInput__bTBRw","formItem":"AuthForm_formItem__PfoM5","icon":"AuthForm_icon__j0hPs","message":"AuthForm_message__iJO1i","politika":"AuthForm_politika__w6GMc"};